import PropTypes from 'prop-types';
import { Permissions } from 'utils/constants/permissions';

import PrivateRoute from 'app/routes/PrivateRoute';

const getUrlRedirect = (permissions) => {
    if (permissions.includes(Permissions.PermissionDenied)) {
        return '/new/forbidden/';
    }
    if (permissions.includes(Permissions.UserNotAuthorized)) {
        return '/new/';
    }
    return '/new/error/';
};

const UserRoute = ({ component, ...props }) => (
    <PrivateRoute
        component={component}
        urlByPermissions={getUrlRedirect}
        allowingPermission={Permissions.ViewPersonalAreaSection}
        {...props}
    />
);

UserRoute.propTypes = {
    component: PropTypes.elementType,
};

export default UserRoute;
